var REM_STANDARD_WIDTH = 375;
var PIXEL_TO_REM_RATIO = 0.1;
var POST_MESSAGE_TYPE = {
  CRYPTO_SIGN_IN_DONE: "crypto_sign_in_done",
  CRYPTO_SIGN_IN_FAILED: "crypto_sign_in_failed",
  RECEIVE_OAUTH_DATA: "receive_oauth_data",
  READY_OAUTH_DATA: "ready_oauth_data"
};
var POST_MESSAGE_SOURCE = "vingle_moim_co_IPC";
var SECONDARY_VIEW_URL_REGEX = /\/panel\/[^ ?]+/g;
var WITHOUT_TIME_DATE_FORMAT = "datetime_format_detail_text_date";
var TEN_MINUTES = 10 * 60 * 1000;
var DEFAULT_CURRENCY = "KRW";
var DEFAULT_MAX_PRICE_STEP = "0.00000001";
var DEFAULT_MAX_PRICE_DECIMALS_LIMIT = DEFAULT_MAX_PRICE_STEP.indexOf(".") >= 0 ? DEFAULT_MAX_PRICE_STEP.substring(DEFAULT_MAX_PRICE_STEP.indexOf(".") + 1, DEFAULT_MAX_PRICE_STEP.length).length : undefined;

export { DEFAULT_CURRENCY, DEFAULT_MAX_PRICE_DECIMALS_LIMIT, DEFAULT_MAX_PRICE_STEP, PIXEL_TO_REM_RATIO, POST_MESSAGE_SOURCE, POST_MESSAGE_TYPE, REM_STANDARD_WIDTH, SECONDARY_VIEW_URL_REGEX, TEN_MINUTES, WITHOUT_TIME_DATE_FORMAT };
